import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom'
import { dateTimeToView } from '../../../../utils/date.utils';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { useMediaQuery, useTheme } from '@mui/material';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { ELibraryManagementApi, list_borrow, list_order_buy } from '../../../../api/e-library/e_library_management';
import StatusCustom from '../../../../components/status/statusCustom';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { routeName } from '../../../../routes/routeName';
import { alertActive, alertSuccess } from '../../../../components/alert/swal';
import { LIBRARY_PAYMENT_STATUS } from '../../enum/elibrary_enum';


export const useManageState = () => {
    // CONSTANCE
    const location = useLocation();
    const path_name = location.pathname;
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();
    const navigate = useNavigate();


    // HOOKS
    const [search, set_search] = useState<string>("");
    const [start_date, set_start_date] = useState<string | null>(null);
    const [end_date, set_end_date] = useState<string | null>(null);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("library_payment_head_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, set_data] = useState<any[]>([]);
    const [library_payment_status, set_library_payment_status] = useState<any>(null);

    const handleChangeDateRange = (st: string | null, end: string | null) => {
        set_start_date(st);
        set_end_date(end);
    }

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_complaints_type", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 100, align: "center", label: t("หมายเลขคำสั่งซื้อ")
        },
        {
            id: "ๅ", disablePadding: false, align: "center", width: 140, label: t("เลขเรียกหนังสือ") // i18n-ignore
        },
        {
            id: "1", disablePadding: false, align: "center", width: 141, label: t("ผู้สั่งซื้อ")
        },
        {
            id: "2", disablePadding: false, align: "center", width: 141, label: t("วันที่สั่งซื้อ")
        },
        {
            id: "action", disablePadding: false, align: "center", margin: "0 2em", width: 220, class: matches && data.length > 0, label: t("สถานะ")
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {

            id_library_payment_head,
            full_name,
            library_payment_head_status,


            order_number,
            library_number_books,
            library_payment_head_date

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "center",
                    label: order_number || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: library_number_books || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: full_name || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: library_payment_head_date ? dateTimeToView(library_payment_head_date) : '-'
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex px-2 justify-between items-center'>
                        <span className='w-full flex justify-start items-center'>
                            <StatusCustom
                                disableMaxWidth
                                sx={{ maxWidth: 'fit-content', px: 3 }}
                                text={library_payment_head_status || ""}
                                type={library_payment_head_status || ""}
                            />
                        </span>
                        <span>
                            <OptionsButtonCustom
                                enableEdit={library_payment_head_status !== LIBRARY_PAYMENT_STATUS.REJECT_PAYMENT}
                                enableView
                                // enableDelete
                                onViewClick={() => {
                                    id_library_payment_head && navigate(routeName.e_library.manage_orders_view.replace(":id", id_library_payment_head));
                                }}
                                onEditClick={() => {
                                    id_library_payment_head && navigate(routeName.e_library.manage_orders_detail.replace(":id", id_library_payment_head));
                                }}
                            // onDeleteClick={() => { }}
                            />
                        </span>
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };



    // const handleDeleteBorrow = (id_library_history: number) => {
    //     alertActive("ลบรายการ", "ต้องการลบรายการนี้?", undefined, undefined, async () => {
    //         dispatch(setLoading())
    //         await ELibraryManagementApi.deleteBorrow(id_library_history).then((res) => {
    //             if (res.status < 300) {
    //                 alertSuccess("ลบรายการ", "ลบรายการ สำเร็จ");
    //                 handleGetData();
    //             }
    //         }).catch((err) => {
    //             console.log(err)
    //         }).finally(() => {
    //             dispatch(unsetLoading());
    //         })
    //     })
    // }
    const handleGetData = useCallback(async () => {
        let query: list_order_buy = {
            page: page,
            limit: pageLimit,
            sortBy,
            sortType
        }
        if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.end_date = moment(end_date).format("YYYY-MM-DD");
        if (search) query.search = search
        if (library_payment_status) query.library_payment_status = library_payment_status?.value
        dispatch(setLoading());
        await ELibraryManagementApi.listOrderBuy(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
                set_data(response)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, start_date, end_date, search, library_payment_status])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        path_name,
        set_search,
        handleChangeDateRange,
        start_date,
        end_date,
        page,
        pageLimit,
        totalItems,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        library_payment_status,
        set_library_payment_status
    }
}

